const getMagiclinkToken = (): string => {
  const params = new URL(window.location.toString()).searchParams;
  const partner = params.get("partner");
  const correlationId = params.get("correlationId");
  const token = params.get("token");

  return partner
    ? "partner=" + partner + (correlationId ? "&correlationId=" + correlationId : "") + (token ? "&token=" + token : "")
    : "";
};

export default getMagiclinkToken;
